import { combineReducers } from 'redux';

import isLoading from './isLoading';

/** @typedef {{isLoading: import('./isLoading').isLoadingState }} ModelState */

export default combineReducers({
  isLoading,
});
